/**
 * Override Dawn's predictive search to include tag-based search
 * and show product variants in results.
 */
(function () {
  // Wait for predictive-search custom element to be defined
  customElements.whenDefined('predictive-search').then(() => {
    const PredictiveSearch = customElements.get('predictive-search');
    if (!PredictiveSearch) return;

    const originalGetSearchResults = PredictiveSearch.prototype.getSearchResults;

    PredictiveSearch.prototype.getSearchResults = function (searchTerm) {
      const queryKey = searchTerm.replace(' ', '-').toLowerCase();
      this.setLiveRegionLoadingState();

      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }

      const searchUrl = `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=product,query,collection&resources[options][fields]=title,body,product_type,tag,variants.title&resources[options][unavailable_products]=last&section_id=predictive-search`;

      fetch(searchUrl, {
        signal: this.abortController.signal,
      })
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search').innerHTML;
          this.allPredictiveSearchInstances.forEach((instance) => {
            instance.cachedResults[queryKey] = resultsMarkup;
          });
          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          if (error?.code === 20) return;
          this.close();
          throw error;
        });
    };
  });
})();
